async function updateSheetValues(
  address,
  type,
  driver,
  script_id,
  service = null
) {
  const complaint = type !== "Complaint" ? "false" : "true";

  // Build base URL
  let url = `https://script.google.com/macros/s/${script_id}/exec?method=updateCompleted&address=${address}&complaint=${complaint}&driver=${driver}`;

  // Append service if provided
  if (service) {
    url += `&service=${encodeURIComponent(service)}`;
  }

  // Call the script
  try {
    await fetch(url);
  } catch (error) {
    console.error("Failed to update sheet:", error);
  }
}

export default updateSheetValues;
